import { useAuth } from '@/auth/useAuth'

/** Convenience hook - most query keys want just the tenant id. */
export function useTenant(): string | null {
  const { user } = useAuth()
  return user?.tenantId ?? null
}
